/**
 * 默认配置
 */

module.exports = {
    //baseURL: process.env.NODE_ENV === 'development' ? 'https://uat.omnimkt.com' : 'https://uat.omnimkt.com',
    // baseURL: process.env.NODE_ENV === 'development' ? 'http://192.168.1.22:8081' : 'https://portal-api.stellantisafc.com.cn/api',
    //baseURL: process.env.NODE_ENV === 'development' ? 'https://api.omnimkt.com/stellantis' : 'https://api.omnimkt.com/stellantis',
    //baseURL: process.env.NODE_ENV === 'development' ? 'https://api.omnimkt.com/stellantis' : 'https://uat-afc.omnimkt.com/api',
    // baseURL: process.env.NODE_ENV === 'development' ? 'https://uat-afc.omnimkt.com/api' : 'https://uat-afc.omnimkt.com/api',
    // baseURL: process.env.NODE_ENV === 'development' ? 'https://uat-afc.omnimkt.com/api' : 'https://portal-api.stellantisafc.com.cn/api',
    baseURL: process.env.NODE_ENV === 'development' ? 'https://portal-api.stellantisafc.com.cn/api' : 'https://portal-api.stellantisafc.com.cn/api',
}

